import {$controller} from "rapid/index";

const dependencies = ["$mdToast"];

export class resetPasswordController extends $controller {

    constructor($injector, $stateParams) {
        "ngInject";
        super($injector, dependencies);
        this.$stateParams = $stateParams;
        this.user = {
            new_password: "",
            re_new_password: "",
            token: this.$stateParams.token
        };
    }



    $onSubmit() {
        this.$auth.$http({
            url: "/api/password/reset/confirm/",
            method: "POST",
            data: this.user
        }).then(() => {
            this.$mdToast.show(
                this.$mdToast.simple().position("bottom right").hideDelay(5000)
                    .textContent(`Password changed!`)
            );
            this.$state.go("auth.signin");
        }).catch(() => {
            this.$mdToast.show(
                this.$mdToast.simple().position("bottom right").hideDelay(3000)
                    .textContent(`Can't change password!`)
            );
        });
    }
}


// WEBPACK FOOTER //
// ./sources/components/auth/reset-password/reset-password.controller.js